// Display date as dd/MMM/yyyy (UTC)

// Kuala Lumpur timezone constant
export const KUALA_LUMPUR_TIMEZONE = 'Asia/Kuala_Lumpur';

// Get today's date in Kuala Lumpur timezone as yyyy-mm-dd
export function getTodayKualaLumpurISODate() {
  const now = new Date();
  // Convert to Kuala Lumpur time
  const klDate = new Date(now.toLocaleString('en-US', { timeZone: KUALA_LUMPUR_TIMEZONE }));
  const year = klDate.getFullYear();
  const month = String(klDate.getMonth() + 1).padStart(2, '0');
  const day = String(klDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Convert a date to yyyy-mm-dd in Kuala Lumpur timezone
export function toKualaLumpurISODate(value) {
  const d = toValidDate(value);
  if (!d) return '';
  const klDate = new Date(d.toLocaleString('en-US', { timeZone: KUALA_LUMPUR_TIMEZONE }));
  const year = klDate.getFullYear();
  const month = String(klDate.getMonth() + 1).padStart(2, '0');
  const day = String(klDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Convert a date to yyyy-mm-dd (strict) in Kuala Lumpur timezone
export function toKualaLumpurISODateStrict(value) {
  return toKualaLumpurISODate(value);
}
export function displayDateDDMMMYYYY(value) {
  if (!value) return '-';
  const d = toValidDate(value);
  if (!d) return '-';
  const day = String(d.getUTCDate()).padStart(2, '0');
  const month = d.toLocaleString('en-GB', { month: 'short', timeZone: 'UTC' });
  const year = d.getUTCFullYear();
  return `${day}/${month}/${year}`;
}

function toValidDate(value) {
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

function getPart(parts, type) {
  const match = parts.find((p) => p.type === type);
  return match ? match.value : '';
}


export function getTodayUTCISODate() {
  const d = new Date();
  return d.toISOString().slice(0, 10);
}



export function toUTCISODateStrict(value) {
  const d = toValidDate(value);
  if (!d) return '';
  // Format as yyyy-mm-dd in UTC
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}


export function toUTCISODate(value) {
  const d = toValidDate(value);
  if (!d) return '';
  // Format as yyyy-mm-dd in UTC
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Format a date value as dd-MMM-yyyy
 */
export function formatDate(value) {
  if (!value) return '-';
  const raw = String(value);
  const plainDate = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (plainDate) {
    const year = plainDate[1];
    const monthNum = Number(plainDate[2]);
    const day = plainDate[3];
    const monthMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthMap[monthNum - 1] || plainDate[2];
    return `${day}-${month}-${year}`;
  }

  const d = toValidDate(value);
  if (!d) return '-';
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: KUALA_LUMPUR_TIMEZONE,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).formatToParts(d);
  const day = getPart(parts, 'day');
  const month = getPart(parts, 'month');
  const year = getPart(parts, 'year');
  return `${day}-${month}-${year}`;
}

/**
 * Format a date value as dd-MMM-yyyy HH:mm (24-hour)
 */
export function formatDateTime(value) {
  if (!value) return '-';
  const raw = String(value).trim();
  const mysqlDateTime = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::\d{2})?$/);
  if (mysqlDateTime && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)) {
    const year = mysqlDateTime[1];
    const monthNum = Number(mysqlDateTime[2]);
    const day = mysqlDateTime[3];
    const hh = mysqlDateTime[4];
    const mm = mysqlDateTime[5];
    const monthMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthMap[monthNum - 1] || mysqlDateTime[2];
    return `${day}-${month}-${year} ${hh}:${mm}`;
  }

  const d = toValidDate(value);
  if (!d) return '-';
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: KUALA_LUMPUR_TIMEZONE,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(d);
  const day = getPart(parts, 'day');
  const month = getPart(parts, 'month');
  const year = getPart(parts, 'year');
  const hh = getPart(parts, 'hour');
  const mm = getPart(parts, 'minute');
  return `${day}-${month}-${year} ${hh}:${mm}`;
}
